import request from '@/utils/request'

/**
 * 用户登录
 */
export function login(data) {
  return request({
    url: '/sso/h5/access_token',
    method: 'post',
    data
  })
}